import { useEffect, useState } from 'react';
import { CalendarClock, ChevronDown, ChevronUp, LocateFixed } from 'lucide-react';
import { isOverdue, getIntervals } from '../lib/maint';
import { fill } from '../lib/license';

export default function OverdueCard({ t, fittings, onLocate }) {
  const [open, setOpen] = useState(false);
  const [, tick] = useState(0);
  useEffect(() => { const on = () => tick((n) => n + 1); window.addEventListener('giss-intervals', on); return () => window.removeEventListener('giss-intervals', on); }, []);
  const iv = getIntervals();
  const due = fittings.filter(isOverdue);
  if (!due.length) return null;
  const fmt = (f) => (f.maint ? `${t.mtLast}: ${new Date(f.maint.date).toLocaleDateString(t.locale)}` : t.dueNever);
  return (
    <section className="panel overdue-card" data-testid="overdue-card">
      <button className="overdue-head" data-testid="overdue-toggle-btn" onClick={() => setOpen(!open)}>
        <CalendarClock size={18} />
        <span><b>{t.dueTitle}</b><small data-testid="overdue-hint">{fill(t.dueHint, { v: iv.valve, h: iv.hydrant })}</small></span>
        <em className="count" data-testid="overdue-count">{due.length}</em>
        {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </button>
      {open && (
        <ul className="overdue-list" data-testid="overdue-list">
          {due.map((f, i) => (
            <li key={f.id}>
              <button data-testid={`overdue-item-${i}`} onClick={() => onLocate(f)}>
                <LocateFixed size={14} /> <b>{f.name || t['fit_' + f.type]}</b> <small>{t['fit_' + f.type]} · {fmt(f)}</small>
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
